<div class="dur-page" [class.dur-page--embedded]="embedded">
  <!-- ═══ Loading ═══ -->
  <div *ngIf="state === 'loading'" class="dur-state-card dur-state-card--loading">
    <mat-spinner diameter="48"></mat-spinner>
    <p>Cargando tu información...</p>
  </div>

  <!-- ═══ Error ═══ -->
  <div *ngIf="state === 'error'" class="dur-state-card dur-state-card--error">
    <mat-icon>error_outline</mat-icon>
    <h2>Ups, algo no salió como esperábamos</h2>
    <p>{{ errorMessage }}</p>
    <button class="dur-btn dur-btn--primary" (click)="retryLoad()">
      <mat-icon>refresh</mat-icon> Reintentar
    </button>
  </div>

  <!-- ═══ Not found ═══ -->
  <div *ngIf="state === 'notFound'" class="dur-state-card dur-state-card--empty">
    <mat-icon>check_circle</mat-icon>
    <h2>¡Todo en orden!</h2>
    <p>No tenés solicitudes de actualización pendientes. Ya podés seguir usando la plataforma con normalidad.</p>
    <button *ngIf="!embedded" class="dur-btn dur-btn--primary" (click)="goHome()">
      <mat-icon>home</mat-icon> Ir al inicio
    </button>
  </div>

  <!-- ═══ Cancelled ═══ -->
  <div *ngIf="state === 'cancelled'" class="dur-state-card dur-state-card--info">
    <mat-icon>info</mat-icon>
    <h2>Esta solicitud fue cancelada</h2>
    <p>Nuestro equipo canceló esta solicitud. Si tenés dudas, contactá a soporte.</p>
    <button *ngIf="!embedded" class="dur-btn dur-btn--primary" (click)="goHome()">
      <mat-icon>home</mat-icon> Ir al inicio
    </button>
  </div>

  <!-- ═══ Completed ═══ -->
  <div *ngIf="state === 'completed'" class="dur-state-card dur-state-card--success">
    <mat-icon>verified</mat-icon>
    <h2>¡Listo! Gracias por mantener tu información al día</h2>
    <p>Nuestro equipo verificó todo correctamente. Ya podés volver a operar sin restricciones.</p>
    <button *ngIf="!embedded" class="dur-btn dur-btn--primary" (click)="goHome()">
      <mat-icon>home</mat-icon> Continuar
    </button>
  </div>

  <!-- ═══ Awaiting review ═══ -->
  <div *ngIf="state === 'awaitingReview'" class="dur-state-card dur-state-card--review">
    <div class="dur-review-illustration">
      <mat-icon>hourglass_top</mat-icon>
    </div>
    <h2>Tu información está en revisión</h2>
    <p>Recibimos los datos que enviaste. Te avisaremos cuando podamos darte acceso de nuevo.</p>
    <button class="dur-btn dur-btn--primary" (click)="acknowledgeReview()">
      <mat-icon>home</mat-icon> Volver al inicio
    </button>
  </div>

  <!-- ═══ Max rejects ═══ -->
  <div *ngIf="state === 'maxRejects'" class="dur-state-card dur-state-card--blocked">
    <mat-icon>support_agent</mat-icon>
    <h2>¡Ya casi! Vamos a ayudarte 💚</h2>
    <p>
      Tuvimos algunos detalles con la información que enviaste. No te preocupes —
      nuestro equipo de soporte está listo para acompañarte y resolverlo juntos en
      pocos minutos.
    </p>
    <div class="dur-state-card__actions">
      <button class="dur-btn dur-btn--whatsapp" (click)="openWhatsAppSupport()">
        <mat-icon>chat</mat-icon>
        Hablar con soporte por WhatsApp
      </button>
      <button *ngIf="!embedded" class="dur-btn dur-btn--secondary" (click)="goHome()">
        <mat-icon>home</mat-icon> Volver al inicio
      </button>
    </div>
  </div>

  <!-- ═══ Modal OTP para verificar cambio de teléfono ═══
       Se muestra ANTES del submit real cuando la solicitud incluye
       teléfono/prefijo. El cliente ingresa el código que llega por
       WhatsApp; solo con código válido se dispara el submit. -->
  <div *ngIf="showOtpModal" class="dur-otp-backdrop" role="dialog" aria-modal="true">
    <div class="dur-otp-modal">
      <header class="dur-otp-modal__header">
        <div class="dur-otp-modal__icon">
          <mat-icon>chat</mat-icon>
        </div>
        <div>
          <h2>Verificación por WhatsApp</h2>
          <p>
            Te enviamos un código de <strong>6 dígitos</strong> por WhatsApp
            al número <strong>{{ otpTargetPhone }}</strong>. Ingresalo abajo
            para confirmar que sos vos.
          </p>
        </div>
      </header>

      <div class="dur-otp-modal__body">
        <input
          type="text"
          inputmode="numeric"
          pattern="[0-9]*"
          autocomplete="one-time-code"
          maxlength="6"
          [(ngModel)]="otpCode"
          class="dur-otp-input"
          placeholder="——————"
          (keyup.enter)="verifyPhoneOtp()"
          [disabled]="otpLoading"
        />

        <div *ngIf="otpError" class="dur-otp-error">
          <mat-icon>error_outline</mat-icon>
          <span>{{ otpError }}</span>
        </div>

        <button
          type="button"
          class="dur-otp-resend"
          (click)="resendPhoneOtp()"
          [disabled]="otpResendCooldown > 0 || otpLoading"
        >
          <span *ngIf="otpResendCooldown === 0">Reenviar código por WhatsApp</span>
          <span *ngIf="otpResendCooldown > 0">
            Reenviar en {{ otpResendCooldown }}s
          </span>
        </button>
      </div>

      <footer class="dur-otp-modal__actions">
        <button
          type="button"
          class="dur-btn dur-btn--secondary"
          (click)="closeOtpModal()"
          [disabled]="otpLoading"
        >
          Cancelar
        </button>
        <button
          type="button"
          class="dur-btn dur-btn--primary"
          (click)="verifyPhoneOtp()"
          [disabled]="otpLoading || otpCode.length !== 6"
        >
          <mat-spinner *ngIf="otpLoading" diameter="16"></mat-spinner>
          <mat-icon *ngIf="!otpLoading">check_circle</mat-icon>
          Verificar código
        </button>
      </footer>
    </div>
  </div>

  <!-- ═══ Form principal (ready / submitting) ═══ -->
  <ng-container *ngIf="request && (state === 'ready' || state === 'submitting')">
    <!-- Header amigable -->
    <header class="dur-header">
      <div class="dur-header__icon">
        <mat-icon>fact_check</mat-icon>
      </div>
      <div class="dur-header__text">
        <h1>¡Hola! Necesitamos validar algunos datos</h1>
        <p>
          Para seguir cuidando tu cuenta, nuestro equipo te pide actualizar la siguiente información.
          Es rápido y nos ayuda a mantener tu perfil al día.
        </p>
      </div>
    </header>

    <!-- Banner motivo + deadline + progress -->
    <section class="dur-summary">
      <div class="dur-summary__row">
        <div
          class="dur-chip dur-chip--deadline"
          [class.dur-chip--expired]="deadlineSeverity === 'expired'"
          [class.dur-chip--urgent]="deadlineSeverity === 'urgent'"
          [class.dur-chip--soon]="deadlineSeverity === 'soon'"
        >
          <mat-icon>schedule</mat-icon>
          <span>{{ deadlineLabel }}</span>
        </div>

        <div class="dur-chip dur-chip--progress">
          <mat-icon>fact_check</mat-icon>
          <span>{{ itemsCompleted }}/{{ itemsTotal }} listos</span>
        </div>
      </div>

      <div class="dur-summary__motivo" *ngIf="request.motivo">
        <strong>¿Por qué te lo pedimos?</strong>
        <span>{{ request.motivo }}</span>
      </div>

      <div class="dur-summary__progress-bar">
        <div
          class="dur-summary__progress-fill"
          [style.width.%]="progressPercent"
        ></div>
      </div>

      <div *ngIf="request.rejectCount > 0" class="dur-summary__reintentos">
        <mat-icon>info</mat-icon>
        <span>
          Algunos datos no se aprobaron y te pedimos corregirlos.
          Reintento {{ request.rejectCount }} de 2.
        </span>
      </div>
    </section>

    <!-- Form: secciones por grupo -->
    <form [formGroup]="scalarForm" (ngSubmit)="submit()" class="dur-form">
      <section
        *ngFor="let group of groups"
        class="dur-section"
      >
        <header class="dur-section__header">
          <mat-icon>{{ group.icon }}</mat-icon>
          <h2>{{ group.label }}</h2>
        </header>

        <div class="dur-section__items">
          <ng-container *ngFor="let item of group.items">
            <!-- Items de archivo -->
            <app-update-field-file
              *ngIf="isFileItem(item)"
              [item]="item"
              [requestId]="request.id || requestId"
              [label]="labelOf(item)"
              [disabled]="state === 'submitting'"
              (fileConfirmed)="onFileConfirmed($event)"
              (uploadStateChange)="onFileUploadStateChange(item.id || item.itemId || '', $event)"
            ></app-update-field-file>

            <!-- Items texto/número/date/boolean/email -->
            <app-update-field-input
              *ngIf="!isFileItem(item)"
              [item]="item"
              [label]="labelOf(item)"
              [control]="controlForItem(item)"
              [disabled]="state === 'submitting'"
            ></app-update-field-input>
          </ng-container>
        </div>
      </section>

      <!-- Footer con acciones -->
      <footer class="dur-form__footer">
        <button
          type="submit"
          class="dur-btn dur-btn--primary"
          [disabled]="state === 'submitting' || !canSubmit"
          [title]="submitBlockedReason || ''"
        >
          <mat-spinner *ngIf="state === 'submitting'" diameter="18"></mat-spinner>
          <mat-icon *ngIf="state !== 'submitting'">send</mat-icon>
          {{ state === 'submitting' ? 'Enviando...' : 'Enviar para revisión' }}
        </button>

        <!-- Motivo del bloqueo (si aplica): guía al cliente sobre qué
             le falta antes de que pueda enviar. Sólo se muestra si el
             botón está deshabilitado con un motivo trazable. -->
        <small
          *ngIf="submitBlockedReason"
          class="dur-form__hint dur-form__hint--warn"
        >
          <mat-icon>info</mat-icon>
          {{ submitBlockedReason }}
        </small>

        <small *ngIf="!submitBlockedReason" class="dur-form__hint">
          Tu información viaja cifrada y queda bajo revisión de nuestro equipo de cumplimiento.
        </small>
      </footer>
    </form>
  </ng-container>
</div>
